module.exports = __webpack_public_path__ + "media/images/bia-niger-9a19a567b5fe9c6e6a8be2a28019f0e3.png";